/**
 * KINDW-1598: PDP-local warehouse inventory context.
 * PDP stock / ATC resolve inventory from the delivery estimate here instead of global cookies
 * that may have been written on checkout.
 */

import React, {createContext, useCallback, useContext, useMemo, useState} from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  inventoryIds: undefined,
  isActive: false,
  isResolving: false,
};

const PdpWarehouseInventoryContext = createContext({
  ...defaultState,
  isPdpScope: false,
  setPdpWarehouseInventoryState: () => {},
});

export function PdpWarehouseInventoryProvider({children}) {
  const [state, setState] = useState(defaultState);

  const setPdpWarehouseInventoryState = useCallback((next) => {
    setState((prev) => ({...prev, ...next}));
  }, []);

  const value = useMemo(
    () => ({...state, isPdpScope: true, setPdpWarehouseInventoryState}),
    [state, setPdpWarehouseInventoryState]
  );

  return (
    <PdpWarehouseInventoryContext.Provider value={value}>
      {children}
    </PdpWarehouseInventoryContext.Provider>
  );
}

export function usePdpWarehouseInventoryContext() {
  return useContext(PdpWarehouseInventoryContext);
}

PdpWarehouseInventoryProvider.propTypes = {
  children: PropTypes.node,
};
